import { z } from "zod";
import { common } from "../common";

// Whether the composer applied a Braze-managed preset or one of the workspace's own saved templates.
const appliedTemplateTypeSchema = z.enum(["preset", "custom"]);

// The template a message variation was created from (MessageVariation#applied_template). The composer sends type, id
// and applied_at when a template is applied, null when the content is cleared, and the value it loaded otherwise
// (omitting the key keeps the stored value). The server snapshots name and content_hmac from the template itself
// and returns them on GET with a signature; the composer never reads them, and must send all three back unchanged for
// the server to keep the snapshot.
export const appliedTemplateSchema = z.object({
  type: appliedTemplateTypeSchema,
  id: common.objectId,
  // Unix seconds; a new value tells the server the template was applied again
  applied_at: common.unixTimestamp,
  name: z.string().optional(),
  content_hmac: z.string().optional(),
  signature: z.string().optional(),
});
